module.exports = __webpack_public_path__ + "media/application/images/ask-banner-c10b4d712aedf762b9faec0e0c3c44c0ae29f36630ce53b80c3dbc13272fbe8c.png";